import { render } from "./PdfViewerObject.vue?vue&type=template&id=3109a200&scoped=true"
import script from "./PdfViewerObject.vue?vue&type=script&lang=js"
export * from "./PdfViewerObject.vue?vue&type=script&lang=js"

import "./PdfViewerObject.vue?vue&type=style&index=0&id=3109a200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3109a200"]])

export default __exports__